import { css } from '@emotion/react';

const stationFooterStyle = {
    container: css({
        color: '#000000',
        padding: '15px 0',
        backgroundColor: '#ffffff',
        maxWidth: '600px',
        width: '100%',
    }),
    title: css({
        margin: '0 0 15px 5px',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '19px',
        lineHeight: '23px',
        textTransform: 'capitalize',
    }),
    content: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    }),
    infoBlock: css({
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    }),
    infoBlockIcon: css({
        marginTop: '5px',
    }),
    infoBlockTitle: css({
        fontStyle: 'normal',
        fontSize: '12px',
        lineHeight: '15px',
        opacity: 0.5,
    }),
    infoBlockValue: css({
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '16px',
        whiteSpace: 'pre-line',
        textDecoration: 'none',
        color: '#000000',

        '&[href^="mailto:"]': {
            color: '#004FC6',
            textDecoration: 'underline',
        },
    }),
    link: css({
        textDecoration: 'none',
        color: '#000000',
    }),
    description: css({
        fontSize: '13px',
        fontWeight: 300,
        lineHeight: '20px',
        color: '#000000',
        margin: '0',
    }),
};

export default stationFooterStyle;
